import { OnboardingScreen } from "./screens/OnboardingScreen";

export default function App() {
  return <OnboardingScreen />;
}
